import { render, staticRenderFns } from "./PritickePack02.vue?vue&type=template&id=18aa3364&scoped=true&"
import script from "./PritickePack02.vue?vue&type=script&lang=js&"
export * from "./PritickePack02.vue?vue&type=script&lang=js&"
import style0 from "./PritickePack02.vue?vue&type=style&index=0&id=18aa3364&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18aa3364",
  null
  
)

export default component.exports